import { ApiError } from '@/api/client'

export type { ErrorCode } from '@/api/types'

// Человекочитаемые русские сообщения по кодам. Отсутствующий код → показываем detail с бэкенда.
const FRIENDLY_BY_CODE: Record<string, string> = {
  INVALID_CREDENTIALS: 'Неверный ID или пароль',
  SAME_PASSWORD: 'Новый пароль совпадает с текущим',
  INVALID_TOKEN: 'Недействительный токен',
  REQUIRED_TOKEN: 'Требуется авторизация',
  WRONG_TOKEN_TYPE: 'Неверный тип токена',
  TOKEN_REUSE: 'Сессия завершена в целях безопасности. Войдите заново',
  FORBIDDEN: 'Недостаточно прав',
  NOT_FOUND: 'Не найдено',
  GROUP_NOT_FOUND: 'Группа не найдена',
  GROUP_WITHOUT_OUTBOUNDS: 'В группе нет ни одного outbound — конфигурацию собрать не из чего',
  OUTBOUND_NOT_FOUND: 'Outbound не найден',
  INVALID_DNS_CONFIG: 'Некорректная DNS-конфигурация',
  INVALID_DOMAIN: 'Некорректный домен',
  INVALID_IP_NETWORK: 'Некорректный IP или CIDR',
  INVALID_OUTBOUND_CONFIG: 'Некорректная конфигурация outbound',
  INVALID_TELEGRAM_FEATURE: 'Некорректная конфигурация Telegram',
  SELF_DELETION: 'Нельзя удалить собственную учётную запись',
  SELF_PASSWORD_RESET: 'Нельзя сбросить пароль собственной учётной записи',
  API_TOKEN_NOT_FOUND: 'Токен доступа не найден',
  TOO_MANY_REQUESTS: 'Слишком много попыток. Попробуйте позже',
  PASSWORD_LOGIN_DISABLED: 'У этой учётной записи есть ключ доступа — входите по ключу',
  INVALID_INVITE: 'Приглашение недействительно или уже использовано',
  INVITE_NOT_FOUND: 'Приглашение не найдено',
  WEBAUTHN_VERIFICATION_FAILED: 'Не удалось проверить ключ. Попробуйте ещё раз',
  CREDENTIAL_NOT_FOUND: 'Ключ доступа не найден',
  INVALID_RECOVERY_CODE: 'Код восстановления неверен или уже использован',
  FEED_TOKEN_NOT_FOUND: 'Установка не найдена или отозвана',
}

// Браузер бросает эти ошибки, когда человек закрыл диалог passkey или отменил Touch ID.
// Это не сбой — показывать красную плашку не за что.
export function isAbortedCeremony(err: unknown): boolean {
  return err instanceof Error && (err.name === 'NotAllowedError' || err.name === 'AbortError')
}

export function getErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code && FRIENDLY_BY_CODE[err.code]) return FRIENDLY_BY_CODE[err.code]
    return err.detail || `Ошибка ${err.status}`
  }
  if (err instanceof Error) return err.message
  return 'Неизвестная ошибка'
}

// Явное сообщение по коду для случаев, где UI хочет перекрыть сообщение точечно.
export function messageForCode(code: string, fallback = 'Ошибка'): string {
  return FRIENDLY_BY_CODE[code] ?? fallback
}
